<template>
  <div class="category_homepanel" v-if="productList && productList.length > 0 ">
    <div class="sub_heading flx">
      <h4>{{title}}</h4>
      <span class="see_all" @click="getMerchandiseProducts()">{{$t('seeAll')}}</span>
    </div>
    <ul class="product_list flx">
      <li
        class="product_card flx"
        :class="{'width100' : productList.length == 1}"
        v-for="(product,index) in productList"
        :key="index"
        @click="goToProductDetail(product.saleReferenceID)"
      >
        <div
          class="img_wrapper spinner_wrapper"          
          v-lazyload
          v-if="product.displayImage"
        >
          <ImageSpinner class="image_spinner" />
          <img :data-url="product.displayImage" alt="product" />
        </div>
        <div class="product_detail">
          <p class="prod_name">{{product.productName}}</p>
          <p class="bought">
            {{product.peopleBought}}
            {{$t('peopleHaveBrought')}}
          </p>
          <div class="my_price_section">
            <span class="my_price">₹​ {{product.groupPrice}}</span>
            <span class="selling_price">₹​ {{product.markedPrice}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ImageSpinner from "../Common/ImageSpinner";
import constant from "../../utils/constant";
import { bus } from "../../main";

export default {
  name: "CollectionProductCard",
  components: {
    ImageSpinner
  },
  props: {
    title: {
      required: true,
      type: String
    },
    dataValue: {
      required: true,
      type: Array
    },
    merchantId: {
      required: true
    },
    getMyPrice: {
      type: Boolean
    }
  },
  watch: {
    dataValue() {
      this.productList = this.dataValue;
    }
  },
  data() {
    return {
      productList: [],
      loading: false,
      cntntLoad: false
    };
  },
  methods: {
    getUserPrice(saleReferenceID, productDto) {
      this.cntntLoad = true;
      this.$store
        .dispatch({
          type: "getUserPriceProduct",
          payload: saleReferenceID
        })
        .then(data => {
          productDto.sellingPrice = data.data.totalPaidAmount;
          this.cntntLoad = false;
        })
        .catch(err => {
          this.cntntLoad = false;
          productDto.sellingPrice = productDto.groupPrice;
          console.log(err);
        });
    },
    getMerchandiseProducts() {
      if (this.$props.title == this.$t("collectionForYou")) {
        this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
        this.$router.push("/product-by-category?type=COLLECTION_FOR_YOU");
      }
    },
    goToProductDetail(productSrId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push({
        path: "/detail/" + productSrId
      });
      if (this.$props.title == this.$t("relatedProduct")) {
        this.$router.go({
          path: "/detail/" + productSrId
        });
      }
    }
  },
  mounted() {
    this.productList = this.dataValue;
  }
};
</script>
